export const mainReviews = [
  {
    id: 1,
    rating: 5,
    title: '빠르고 정확한 작업, 만족합니다',
    tags: ['#빠른작업', '#전문성', '#합리적가격'],
    content: '구인광고 디자인을 의뢰했는데 생각보다 훨씬 빠르게 완성되었습니다. 디자인도 깔끔하고 정보 전달이 명확해서 지원자가 많이 늘었어요. 수정도 1회 포함이라 부담 없이 요청할 수 있었고, 결과물에 매우 만족합니다. 다음에 홈페이지도 맡길 예정입니다.',
    author: '김OO 실장',
    company: '강남 OO클럽',
    initial: '김',
  },
  {
    id: 2,
    rating: 5,
    title: '업체 이미지가 확 달라졌어요',
    tags: ['#고급스러움', '#모바일최적화', '#효과만점'],
    content: '홈페이지 제작을 맡겼는데 우리 업체 분위기를 정말 잘 살려주셨어요. 고급스러운 느낌이 확 살아나서 손님들 반응이 너무 좋습니다. 모바일에서도 깔끔하게 보여서 예약 문의가 확실히 늘었어요. 가격 대비 퀄리티가 정말 훌륭합니다.',
    author: '박OO 사장님',
    company: '서울 XX바',
    initial: '박',
  },
  {
    id: 3,
    rating: 5,
    title: '유흥업계 특성을 잘 아시네요',
    tags: ['#업계이해도', '#맞춤디자인', '#추천'],
    content: '다른 곳에서는 유흥업계 특성을 잘 몰라서 답답했는데, 여기는 정말 전문가시더라고요. 우리가 원하는 걸 정확히 이해하고 디자인에 반영해주셨어요. 상담부터 결과물까지 모든 과정이 만족스러웠습니다. 주변 사장님들한테 추천하고 다닙니다.',
    author: '이OO 사장님',
    company: '부산 △△클럽',
    initial: '이',
  },
];

export const gridReviews = [
  {
    id: 1,
    rating: 5,
    title: '가성비 최고예요',
    tags: ['#가성비', '#합리적'],
    content: '5만원에 이 퀄리티면 정말 합리적이에요. 다른 곳은 훨씬 비싼데 여기는 가격도 착하고 결과물도 좋아서 너무 만족합니다...',
    author: '박OO 사장님',
    company: '서울 OO바',
    initial: '박',
  },
  {
    id: 2,
    rating: 5,
    title: '전문적인 디자인',
    tags: ['#전문성', '#디테일'],
    content: '유흥업계 특성을 잘 이해하고 계셔서 디자인이 딱 맞아요. 세세한 부분까지 신경 써주셔서 감사합니다...',
    author: '이OO 실장',
    company: '부산 △△클럽',
    initial: '이',
  },
  {
    id: 3,
    rating: 5,
    title: '빠른 응대 감사합니다',
    tags: ['#빠른응대', '#친절'],
    content: '상담부터 결과물까지 빠르게 진행되어서 좋았습니다. 급하게 필요했는데 딱 맞춰주셔서 정말 감사해요...',
    author: '최OO 박스',
    company: '강남 XX룸',
    initial: '최',
  },
  {
    id: 4,
    rating: 5,
    title: '홈페이지 퀄리티 좋아요',
    tags: ['#퀄리티', '#효과'],
    content: '홈페이지 만들었는데 손님 문의가 확실히 늘었어요. 디자인도 세련되고 사용하기도 편해서 만족합니다...',
    author: '정OO 사장님',
    company: '홍대 OO펍',
    initial: '정',
  },
  {
    id: 5,
    rating: 5,
    title: '추천합니다',
    tags: ['#추천', '#만족'],
    content: '주변 사장님들한테 추천하고 다닙니다. 진짜 잘하세요. 다음에 또 맡길 일 있으면 꼭 여기로 올게요...',
    author: '한OO 실장',
    company: '신촌 △△바',
    initial: '한',
  },
  {
    id: 6,
    rating: 5,
    title: '재의뢰 예정입니다',
    tags: ['#재의뢰', '#신뢰'],
    content: '이번에 또 다른 매장 홈페이지 맡길 예정입니다. 첫 작업이 너무 만족스러워서 바로 결정했어요...',
    author: '윤OO 사장님',
    company: '강남 XX살롱',
    initial: '윤',
  },
];